import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconDateGrey } from '@/assets/svgs/icon-date-grey.svg';
import { ReactComponent as IconStatusExclmation } from '@/assets/svgs/icon-status-exclamation.svg';
import { ReactComponent as IconStatusTick } from '@/assets/svgs/icon-status-tick.svg';
import Button from "@/components/Button";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import { Select, SelectContent } from '@dextech-ai/dex-design-system';
import { renderValueOptions, selectedOptionValue } from '@/utils/select-items';
import Input from '@/components/Input';
import Modal from '@/componentsDS/Modal/Modal';
import Portal from "@/components/Portal";
import Toast from '@/components/Toast';
import useModal from '@/hooks/use-modal';
import useMyInfo from "@/hooks/use-my-info";
import usePage from "@/hooks/use-page";
import useProfile from "@/hooks/use-participant-profile";
import useToast from '@/hooks/use-toast';
import useUseCases from "@/hooks/use-use-cases";
import API from '@/services/api/myenrol';
import rem from '@/utils/rem';
import { validateEmail } from "@/utils/validate-email.js";
import classname from 'classnames';
import * as moment from 'moment';
import { forwardRef, Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useForm } from 'react-hook-form';
// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from '@/componentsDS/Breadcrumbs/index';
import Breadcrumb from '@/dsComponents/Breadcrumb';
const Page = () => {
	/*=================================================
		General
	/================================================*/

	const [pageTitle, setPageTitle] = useState("Use Case");
	const [subPageTitle, setSubPageTitle] = useState("Enrolment Application");

	const userTypes = {
		participant: "participant",
		admin: "admin",
		nonParticipant: "nonParticipant"
	}

	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING",
		notEnrolled: "NOT_ENROLLED",
		signdsa: "DSA_REQUESTED",
		informationRequired: "INFO_REQUESTED"
	}

	const toastType = {
		success: "success",
		error: "error"
	}

	const { breadcrumbsItems } = usePage({
		title: subPageTitle,
		breadcrumbs: [
			{
				label:'',
				link:'/'
			},
			{
				label: subPageTitle,
				linke:''
			}
		],
	});

	const [allowEdit, setAllowEdit] = useState(false)
	const [startDate, setStartDate] = useState();

	const [companyType, setCompanyType] = useState()
	const [countryIncorporate, setCountryIncorporate] = useState()
	const [companyStatus, setCompanyStatus] = useState()
	const [appointmentNationality, setAppointmentNationality] = useState()
	const [appointmentCompanyPosition, setAppointmentCompanyPosition] = useState()

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { register, handleSubmit, formState: { errors, isValid } } = useForm({
		mode: 'onChange'
	})

	const { currentItem: currentProfile, setCurrentItem: setCurrentProfile, find: fetchProfile, error: errorProfile } = useProfile()
	const { fetch: fetchUseCase, setCurrentItem: setUseCaseItem, currentItem: useCaseItem, items: useCaseItems, error: errorUseCase} = useUseCases();
	const { fetch: fetchMyInfo, currentItem: myInfoItem, error: errorMyInfo} = useMyInfo();

	async function fetchProfileData() {
		const profile = await fetchProfile()
		setCurrentProfile(profile)

		const incorporateDate = new Date(profile?.organization?.incorporationDate)

		setStartDate(incorporateDate)

		setCompanyType(profile?.organization?.companyType)
		setCountryIncorporate(profile?.organization?.countryofIncorporation)
		setCompanyStatus(profile?.organization?.companyStatus)
		setAppointmentNationality(profile?.organization?.appointmentNationality)
		setAppointmentCompanyPosition(profile?.organization?.appointmentPosition)
	}

	useEffect(() => {
		async function getData() {
			await fetchProfileData()

			fetchMyInfo();
		}
		getData()
	}, []);

	useEffect(() => {
		const useCaseId = currentProfile?.organization?.adminRequest?.orgPersona[0]?.useCaseId

		async function getData() {
			const response = await fetchUseCase({useCaseId: useCaseId})
			setUseCaseItem(response[0])
		}
		getData()

	}, [currentProfile]);

	useEffect(()=>{
		addToastMessage(errorProfile, toastType.error)
	}, [errorProfile])

	/*=================================================
		Modal
	/================================================*/

	const { visible: visibleConfirmation, show: showConfirmation, hide: hideConfirmation } = useModal()

	/*=================================================
		Stepper Status
	/================================================*/

	const StepperStatus = ({status}) => {
		return (
			<div className="status-stepper">
				<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--success">
					<div className="status-stepper__item__left">
						<IconStatusTick />
					</div>
					<div className="status-stepper__item__right">
						<div className="status-stepper__item__top">
							Application Submitted
						</div>
						<div className="status-stepper__item__bottom">
							<span
								className='link'
							>View application</span>
						</div>
					</div>
				</div>

				{status === statuses.informationRequired && (
					<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--warning">
						<div className="status-stepper__item__left">
							<IconStatusExclmation />
						</div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Information Required
							</div>
							<div className="status-stepper__item__bottom">
								We need a bit more information from you to process your application.<br/>
								<span className='link' onClick={()=>showConfirmation()}>View details</span>
							</div>
						</div>
					</div>
				)}

				{status === statuses.signdsa && (
					<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--warning">
						<div className="status-stepper__item__left">
							<IconStatusExclmation />
						</div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Pending Action
							</div>
							<div className="status-stepper__item__bottom">
								We’ve sent a Data Sharing Agreement to your appointee to review and sign via Docusign. Have them check their inbox to proceed.
							</div>
						</div>
					</div>
				)}

				{status !== statuses.signdsa && status !== statuses.rejected &&(
					<div className="status-stepper__item">
						<div className="status-stepper__item__left">
							<IconStatusTick />
						</div>
						<div className="status-stepper__item__right">
							Sign Data Sharing Agreement
						</div>
					</div>
				)}

				{status === statuses.rejected && (
					<div className="status-stepper__item status-stepper__item__active--error">
						<div className="status-stepper__item__left">
							<IconStatusExclmation />
						</div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Application Rejected
							</div>
							<div className="status-stepper__item__bottom">
								Sorry, we had to reject your application. <br/>
								<span className='link' onClick={()=>showConfirmation()}>View details</span>
							</div>
						</div>
					</div>
				)}

				{status !== statuses.rejected && (
					<div className="status-stepper__item">
						<div className="status-stepper__item__left"></div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Start Exchanging!
							</div>
						</div>
					</div>
				)}

			</div>
		)

	}

	/*=================================================
		Selected List Details
	/================================================*/

	const SelectedListDetails = () => {
		return (
			<div className="selected-lists__display">
				<div className="selected-lists__container">
					<div className="selected-list__heading-item">Selected Use Case</div>
					<div className="selected-list__content-text">{useCaseItem?.name}</div>
				</div>
				<div className="selected-lists__container">
					<div className="selected-list__heading-item">Selected Personas</div>
					<div className="selected-list__content-text">
						{currentProfile?.organization?.adminRequest?.orgPersona.map( (persona, index)=> {
							return (
								<Fragment key={index}>
									{persona.personaId + ", "}
								</Fragment>
							)
						} )}

					</div>
				</div>
			</div>
		)
	};

	const CustomDateInput = forwardRef(({value, onClick }, ref) => {
		const calendarClass = classname({
			'date_picker__format': true,
			'date_picker__format__view-enrolment': true,
			'date_picker__format--disabled' : !allowEdit
		})

		return (
			<div className={calendarClass} onClick={onClick} ref={ref}>
				{
					!value && (
						<>
							<IconDateGrey />
							<span className="date_picker__selected-empty_color">
								{"Select date"}
							</span>
						</>
					)
				}
				{
					value && (
						<span>
							{value}
						</span>
					)
				}
			</div>
		)
	})

	async function handlerForm(inputs) {
		const payload = {
			fullName: inputs.full_name,
			mobile: inputs.mobile_number,
			email: currentProfile?.email,
			org: {
				name: inputs.company_name,
				uen: inputs.company_registration_no,
				companyType: companyType,
				incorporationDate: moment.parseZone(startDate).utc(true).format(),
				countryofIncorporation: countryIncorporate,
				companyStatus: companyStatus,
				registeredAddress: inputs.company_registration_address,
				appointmentIdNumber: inputs.company_registration_no,
				appointmentName: inputs.appointment_name,
				appointmentNationality: appointmentNationality,
				appointmentEmail: inputs.appointment_email,
				appointmentMobile: inputs.appointment_number,
				appointmentPosition: appointmentCompanyPosition
			}
		}

		const [error, response] = await API.putRequestParams(currentProfile.organization.adminRequest.id ,payload)

		if(error) {
			return addToastMessage("Failed to register account.", toastType.error)
		}

		addToastMessage("You have update the enrolment.", toastType.success)

		await fetchProfileData()

		setAllowEdit(false)
	}

	return (
		<>
			{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
			{/* <Breadcrumbs breadcrumbItems={breadcrumbsItems} /> */}
			<Breadcrumb items={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title" data-testid="page-title">
						{subPageTitle}
					</div>
				</div>
				{ currentProfile?.organization?.status === statuses.informationRequired && allowEdit === false && (
						<div className="title-header__right">
							<div className="overview__filter overview__button_wrap">
								<Button round full maxWidth={140} text="Edit Form" submit={()=> setAllowEdit(true) } />
							</div>
						</div>
					)
				}
			</div>

			<div className="layout-view-enrolment__container">
				<div className="layout-view-enrolment__container__left">
					<div className="grid__container">
						<div className="grid__title">
							Enrollment Status
						</div>
						<div className="grid">
							<div className="grid__cols">
								<div className='grid__col'>
									<div className="card ">
										<StepperStatus
											status={currentProfile?.organization?.status}
										/>
										<div className="card__content__footer card__content__footer--status">
											For queries reach us at <a className='link' href="mailto:support@sgtradex.com">support@sgtradex.com</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="layout-view-enrolment__container__right">
					<SelectedListDetails />

					<form id="update-enrolment-form" onSubmit={handleSubmit(data => handlerForm(data))}>
						<hr />
						<div className="my-enrol__heading">Personal Information</div>

						<div className="layout-view-enrolment__container__cols">
							<div className="layout-view-enrolment__container__col">
								<Input
									name="full_name"
									label="Full Name"
									register={register({ required: true })}
									error={errors.full_name}
									errorMessage="required"
									defaultValue={currentProfile?.firstName}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<Input
									name="email_address"
									label="Email Address"
									register={register({ required: true, validate: validateEmail })}
									error={errors.email_address}
									errorMessage="required"
									defaultValue={currentProfile?.email}
									disabled={true}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<Input
									name="mobile_number"
									label="Mobile Number"
									register={register({ required: true })}
									error={errors.mobile_number}
									errorMessage="required"
									defaultValue={currentProfile?.mobileNumber}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
						</div>

						<hr />
						<div className="my-enrol__heading">Corporate Information</div>

						<div className="layout-view-enrolment__container__cols">
							<div className="layout-view-enrolment__container__col">
								<Input
									name="company_name"
									label="Company Name"
									register={register({ required: true })}
									error={errors.company_name}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.name}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<Input
									name="company_registration_no"
									label="Company Registration Number / UEN"
									register={register({ required: true })}
									error={errors.company_registration_no}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.uen}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Company Type</div>
									<Select
										data-testid="view-sgtradex-company-type"
										placeholder="Select"
										value={selectedOptionValue(myInfoItem?.companyTypes, companyType)}
										disabled={!allowEdit}
										onChange={(data) => setCompanyType(data)}
									>
										<SelectContent>{renderValueOptions(myInfoItem?.companyTypes)}</SelectContent>
									</Select>
								</div>
							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Date of Incorporation</div>
									<DatePicker
										selected={startDate}
										onChange={(date) => setStartDate(date)}
										id={"date_of_incorporation"}
										dateFormat="yyyy-MM-dd"
										isClearable={allowEdit ? (startDate ? true : false) : false}
										readOnly={!allowEdit}
										customInput={<CustomDateInput />}
									/>
								</div>

							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Country of Incorporation</div>
									<Select
										data-testid="view-sgtradex-country-incorporate"
										placeholder="Select"
										value={selectedOptionValue(myInfoItem?.countryOfIncorp, countryIncorporate)}
										disabled={!allowEdit}
										onChange={(data) => setCountryIncorporate(data)}
									>
										<SelectContent>{renderValueOptions(myInfoItem?.countryOfIncorp)}</SelectContent>
									</Select>
								</div>
							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Company Status</div>
									<Select
										data-testid="view-sgtradex-company-status"
										placeholder="Select"
										value={selectedOptionValue(myInfoItem?.companyStatus, companyStatus)}
										disabled={!allowEdit}
										onChange={(data) => setCompanyStatus(data)}
									>
										<SelectContent>{renderValueOptions(myInfoItem?.companyStatus)}</SelectContent>
									</Select>
								</div>
							</div>
							<div className="layout-view-enrolment__container__col layout-view-enrolment__container__col--2-col">
								<Input
									name="company_registration_address"
									label="Company Registered Address"
									register={register({ required: true })}
									error={errors.company_registration_address}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.registeredAddress}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
						</div>

						<hr />
						<div className="my-enrol__heading">Appointments</div>

						<div className="layout-view-enrolment__container__cols">
							<div className="layout-view-enrolment__container__col">
								<Input
									name="appointment_name"
									label="Name"
									register={register({ required: true })}
									error={errors.appointment_name}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.appointmentName}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Nationality</div>
									<Select
										data-testid="view-sgtradex-appointment-nationality"
										placeholder="Select"
										value={selectedOptionValue(myInfoItem?.nationality, appointmentNationality)}
										disabled={!allowEdit}
										onChange={(data) => setAppointmentNationality(data)}
									>
										<SelectContent>{renderValueOptions(myInfoItem?.nationality)}</SelectContent>
									</Select>
								</div>
							</div>
							<div className="layout-view-enrolment__container__col">
								<Input
									name="appointment_email"
									label="Email Address"
									register={register({ required: true })}
									error={errors.appointment_email}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.appointmentEmail}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<Input
									name="appointment_number"
									label="Mobile Number"
									register={register({ required: true })}
									error={errors.appointment_number}
									errorMessage="required"
									defaultValue={currentProfile?.organization?.appointmentMobile}
									disabled={!allowEdit}
									onBlur={(e)=>e.target.value = e.target.value.trim()}
								/>
							</div>
							<div className="layout-view-enrolment__container__col">
								<div className="input-field">
									<div className='input-field__label input-field__label--margin-bottom'>Company Appointment</div>
									<Select
										data-testid="view-sgtradex-appointment-company-position"
										placeholder="Select"
										value={selectedOptionValue(myInfoItem?.companyAppointment, appointmentCompanyPosition)}
										disabled={!allowEdit}
										onChange={(data) => setAppointmentCompanyPosition(data)}
									>
										<SelectContent>{renderValueOptions(myInfoItem?.companyAppointment)}</SelectContent>
									</Select>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>

			{
				allowEdit === true && (
					<div className='DS__layout__footer'>
						<div className="layout-default__sticky-actions">
							<div className="layout-default__sticky-actions__left"> </div>
							<div className="layout-default__sticky-actions__right layout-default--flex">
								<div className="layout-default--margin-right">

								</div>
								<Button text="Submit"
									form="update-enrolment-form"
									full
								/>
							</div>
						</div>
					</div>
				)
			}


			<Modal visible={visibleConfirmation} variant='medium' close={hideConfirmation}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Details
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{currentProfile?.organization?.adminRequest?.comment}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList}  />
		</>
	);
};

export default Page;
